import React from "react";

const Icon = () => {
  return (
    <>
      <svg
        width="40"
        height="40"
        viewBox="0 0 512 512"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 89.825C0 40.216 40.216 0 89.825 0H422.175C471.784 0 512 40.216 512 89.825V422.175C512 471.784 471.784 512 422.175 512H89.825C40.216 512 0 471.784 0 422.175V89.825Z"
          fill="url(#paint0_linear)"
        />
        <path
          d="M386 371.5H126C120.5 371.5 116 375.831 116 381.125V400.375C116 405.669 120.5 410 126 410H386C391.5 410 396 405.669 396 400.375V381.125C396 375.831 391.5 371.5 386 371.5ZM426 179C409.438 179 396 191.934 396 207.875C396 212.146 397 216.116 398.75 219.786L353.5 245.894C343.875 251.428 331.438 248.3 325.875 238.916L274.938 153.133C281.625 147.839 286 139.898 286 130.875C286 114.934 272.562 102 256 102C239.438 102 226 114.934 226 130.875C226 139.898 230.375 147.839 237.062 153.133L186.125 238.916C180.562 248.3 168.062 251.428 158.5 245.894L113.312 219.786C115 216.177 116.062 212.146 116.062 207.875C116.062 191.934 102.625 179 86.0625 179C69.5 179 56 191.934 56 207.875C56 223.816 69.4375 236.75 86 236.75C87.625 236.75 89.25 236.509 90.8125 236.269L136 352.25H376L421.188 236.269C422.75 236.509 424.375 236.75 426 236.75C442.562 236.75 456 223.816 456 207.875C456 191.934 442.562 179 426 179Z"
          fill="white"
        />
        <defs>
          <linearGradient
            id="paint0_linear"
            x1="484"
            y1="22"
            x2="112.5"
            y2="382"
            gradientUnits="userSpaceOnUse"
          >
            <stop stop-color="#4776E6" />
            <stop offset="1" stop-color="#8E54E9" />
          </linearGradient>
        </defs>
      </svg>
    </>
  );
};

export default Icon;
